"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/stream/v1/admin_service.proto (package spwn.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminStreamService = void 0;
const admin_service_pb_1 = require("./admin_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.stream.v1.AdminStreamService
 */
exports.AdminStreamService = {
    typeName: "spwn.stream.v1.AdminStreamService",
    methods: {
        /**
         * @generated from rpc spwn.stream.v1.AdminStreamService.GetHoldingStreamInfo
         */
        getHoldingStreamInfo: {
            name: "GetHoldingStreamInfo",
            I: admin_service_pb_1.AdminStreamServiceGetHoldingStreamInfoRequest,
            O: admin_service_pb_1.AdminStreamServiceGetHoldingStreamInfoResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 限定配信機能関連 https://www.notion.so/balusco/3f4c0f3842844e58a23bfe8236c79f67
         * 限定配信設定取得
         *
         * @generated from rpc spwn.stream.v1.AdminStreamService.GetRestrictedStreamingSetting
         */
        getRestrictedStreamingSetting: {
            name: "GetRestrictedStreamingSetting",
            I: admin_service_pb_1.AdminStreamServiceGetRestrictedStreamingSettingRequest,
            O: admin_service_pb_1.AdminStreamServiceGetRestrictedStreamingSettingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 限定配信ページURLの作成
         *
         * @generated from rpc spwn.stream.v1.AdminStreamService.CreateRestrictedStreamingPageUrl
         */
        createRestrictedStreamingPageUrl: {
            name: "CreateRestrictedStreamingPageUrl",
            I: admin_service_pb_1.AdminStreamServiceCreateRestrictedStreamingPageUrlRequest,
            O: admin_service_pb_1.AdminStreamServiceCreateRestrictedStreamingPageUrlResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 限定配信設定の更新
         *
         * @generated from rpc spwn.stream.v1.AdminStreamService.UpdateRestrictedStreamingSetting
         */
        updateRestrictedStreamingSetting: {
            name: "UpdateRestrictedStreamingSetting",
            I: admin_service_pb_1.AdminStreamServiceUpdateRestrictedStreamingSettingRequest,
            O: admin_service_pb_1.AdminStreamServiceUpdateRestrictedStreamingSettingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 限定配信設定の削除
         *
         * @generated from rpc spwn.stream.v1.AdminStreamService.DeleteRestrictedStreamingSetting
         */
        deleteRestrictedStreamingSetting: {
            name: "DeleteRestrictedStreamingSetting",
            I: admin_service_pb_1.AdminStreamServiceDeleteRestrictedStreamingSettingRequest,
            O: admin_service_pb_1.AdminStreamServiceDeleteRestrictedStreamingSettingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * MediaPackageのエンドポイント一覧を取得する
         *
         * @generated from rpc spwn.stream.v1.AdminStreamService.GetMediaPackageEndpoints
         */
        getMediaPackageEndpoints: {
            name: "GetMediaPackageEndpoints",
            I: admin_service_pb_1.AdminStreamServiceGetMediaPackageEndpointsRequest,
            O: admin_service_pb_1.AdminStreamServiceGetMediaPackageEndpointsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * MediaLiveのチャンネル一覧を取得する
         *
         * @generated from rpc spwn.stream.v1.AdminStreamService.GetMediaLiveChannels
         */
        getMediaLiveChannels: {
            name: "GetMediaLiveChannels",
            I: admin_service_pb_1.AdminStreamServiceGetMediaLiveChannelsRequest,
            O: admin_service_pb_1.AdminStreamServiceGetMediaLiveChannelsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * プレミア配信のスケジュール設定を取得する
         *
         * @generated from rpc spwn.stream.v1.AdminStreamService.GetPremierStreamingSchedule
         */
        getPremierStreamingSchedule: {
            name: "GetPremierStreamingSchedule",
            I: admin_service_pb_1.AdminStreamServiceGetPremierStreamingScheduleRequest,
            O: admin_service_pb_1.AdminStreamServiceGetPremierStreamingScheduleResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=admin_service_connect.js.map